import React, { useState } from 'react';
import { Download, Share2, Trash2, X } from 'lucide-react';
import { Document } from '../../types';
import { useDeals } from '../../store/DealsContext';

interface DocumentActionsProps {
  document: Document;
  onClose: () => void;
}

export default function DocumentActions({ document, onClose }: DocumentActionsProps) {
  const { deleteDocument, shareDocument } = useDeals();
  const [showShareModal, setShowShareModal] = useState(false);
  const [email, setEmail] = useState('');

  const handleDownload = () => {
    // In a real app, this would trigger a file download
    console.log(`Downloading document: ${document.name}`);
  };

  const handleShare = (e: React.FormEvent) => {
    e.preventDefault();
    shareDocument(document.id, email);
    setShowShareModal(false);
  };

  const handleDelete = () => {
    if (window.confirm('Are you sure you want to delete this document?')) {
      deleteDocument(document.id);
      onClose();
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md">
        <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
          <h3 className="text-lg font-medium text-gray-900">Document Actions</h3>
          <button onClick={onClose}>
            <X className="w-5 h-5 text-gray-400 hover:text-gray-600" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <div className="flex flex-col space-y-2">
            <button
              onClick={handleDownload}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg"
            >
              <Download className="w-4 h-4 mr-2" />
              Download
            </button>
            
            <button
              onClick={() => setShowShareModal(true)}
              className="flex items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 rounded-lg"
            >
              <Share2 className="w-4 h-4 mr-2" />
              Share
            </button>
            
            <button
              onClick={handleDelete}
              className="flex items-center px-4 py-2 text-sm text-red-600 hover:bg-red-50 rounded-lg"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Delete
            </button>
          </div>
        </div>

        {showShareModal && (
          <div className="p-6 border-t border-gray-200">
            <form onSubmit={handleShare} className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">
                  Share with (email)
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
                  required
                />
              </div>
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setShowShareModal(false)}
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-4 py-2 text-sm font-medium text-white bg-blue-600 border border-transparent rounded-md hover:bg-blue-700"
                >
                  Share
                </button>
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  );
}